export default "__VITE_ASSET__m1i_pKXo__"